module.exports = __webpack_public_path__ + "static/media/SmartShop_1-480w.8f6a86c3.png";